/**
 * 管理员 接口的统一出口
 */
import axios from '../http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

const api = '/c-api/'

const manager = {
    list(params) {
        return axios.get(api + 'admin/list', { params: params })
    },
    /* 添加管理员/代销员*/
    createmanager(params) {
        return axios.post(api + 'admin/create', qs.stringify(params))
    },
    // 修改管理员/代销员
    editmanager(params) {
        return axios.post(api + 'admin/editinfo', qs.stringify(params))
    },
    // 删除管理员/代销员
    deletemanager(params) {
        return axios.post(api + 'admin/status', qs.stringify(params))
    }
    
}

// 导出接口
export default manager
